import AddPlaceholder from './AddPlaceholderModal';

export default AddPlaceholder;
